<template>
    <div class="pick-h5">
        <audio id="pickSuccessAudio" src="../../../images/拣货成功.mp3" preload="auto"></audio>
        <audio id="errorAudio" src="../../../images/出错了.mp3" preload="auto"></audio>
        <!-- 批次号信息和完成按钮 -->
        <div class="batch-info">
            <div class="batch-number">
                <span class="batch-label">批次号:</span>
                <span class="batch-value">{{ batchNumber }}</span>
            </div>
            <button v-if="!isBatchCompleted"
                    @click="handleCompletePick"
                    class="complete-batch-btn">
                完成拣货
            </button>
        </div>

        <!-- 搜索条件 -->
        <div class="search-box">
            <div class="search-row">
                <input type="text"
                       v-model="searchKeyword"
                       placeholder="请输入产品编码"
                       class="search-input"
                       @keyup.enter="handleSearch" />
                <button @click="handleSearch" class="search-btn">搜索</button>
            </div>
        </div>

        <!-- 拣货列表 -->
        <div class="pick-list">
            <div v-for="item in filteredList" :key="item.id" class="pick-item">
                <!-- 左边图片 -->
                <div class="item-left">
                    <img :src="getImageUrl(item.productImgGuid)" class="product-img" />
                </div>

                <!-- 右边内容区域 -->
                <div class="item-right">
                    <!-- 三列数据：产品内码、需要数量、已拣数量 -->
                    <div class="stats-row">
                        <div class="stat-col">
                            <div class="stat-label">产品内码</div>
                            <div class="stat-value">{{ item.productId }}</div>
                        </div>
                        <div class="stat-col">
                            <div class="stat-label">需要数量</div>
                            <div class="stat-value">{{ item.count }}</div>
                        </div>
                        <div class="stat-col">
                            <div class="stat-label">已拣数量</div>
                            <div class="stat-value" :class="{ 'complete': item.isPick, 'incomplete': !item.isPick }">
                                {{ item.pickCount }}
                            </div>
                        </div>
                    </div>


                    <!-- 产品编号 - 单独一行 -->
                    <div class="info-row">
                        <span class="info-label">产品编号:</span>
                        <span class="info-value">{{ item.productNo }}</span>
                    </div>

                    <!-- 货架号 - 单独一行 -->
                    <div class="info-row">
                        <span class="info-label">货架号:</span>
                        <span class="info-value">{{ item.shelfPosition }}</span>
                    </div>

                    <!-- 操作按钮：只有当未完成时才显示 -->
                    <div v-if="!item.isPick&& !isBatchCompleted" class="action-row">
                        <button @click="openPickModal(item)" class="pick-btn">完成拣货</button>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="filteredList.length === 0" class="empty-state">
                暂无数据
            </div>
        </div>

        <!-- 拣货弹框 -->
        <Modal v-model="showPickModal" title="完成拣货" :closable="false" :mask-closable="false" width="90%">
            <div class="modal-content">
                <div class="modal-item">
                    <span class="modal-label">产品编号:</span>
                    <span class="modal-value">{{ currentItem ? currentItem.productNo : '' }}</span>
                </div>
                <div class="modal-item">
                    <span class="modal-label">需要数量:</span>
                    <span class="modal-value">{{ currentItem ? currentItem.count : 0 }}</span>
                </div>
                <div class="modal-item">
                    <span class="modal-label">已拣数量:</span>
                    <span class="modal-value">{{ currentItem ? currentItem.pickCount : 0 }}</span>
                </div>
                <div class="modal-item">
                    <span class="modal-label">拣货数量:</span>
                    <input type="number" v-model="pickCount" class="modal-input" min="0" :max="currentItem ? currentItem.count : 0" />
                </div>
            </div>
            <div slot="footer">
                <Button type="text" @click="closePickModal">取消</Button>
                <Button type="primary" @click="confirmPick">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'BackStockPickH5',
        data() {
            return {
                searchKeyword: '',
                shouldFilter: false,  // 是否应该进行过滤
                showPickModal: false,
                currentItem: null,
                pickCount: 0,
                batchId: null,
                batchNumber: '',
                pickDetailList: [],
                isBatchCompleted: false,
            };
        },

        computed: {
            filteredList() {
                if (!this.pickDetailList || this.pickDetailList.length === 0) {
                    return [];
                }

                // 只有应该过滤且有关键词时才过滤
                if (this.shouldFilter && this.searchKeyword && this.searchKeyword.trim()) {
                    const keyword = this.searchKeyword.trim();
                    return this.pickDetailList.filter(item =>
                        item.productNo && item.productNo === keyword
                    );
                }

                // 否则显示全部
                return this.pickDetailList;
            },

            // 检查是否有未完成的商品
            hasIncompleteItems() {
                if (!this.pickDetailList || this.pickDetailList.length === 0) {
                    return false;
                }
                return this.pickDetailList.some(item => item.isPick === false);
            }
        },
        mounted() {
            // 从query中获取参数，刷新页面也不会丢失
            this.batchId = this.$route.query.id;
            this.batchNumber = this.$route.query.batchNumber || '';
            this.isBatchCompleted = this.$route.query.isBatchCompleted === 'true';

            if (this.batchId) {
                this.loadPickDetail();
            } else {
                this.$Message.error('缺少批次ID');
            }
        },
        methods: {
            ...mapActions('backStockOrderBatch', ['getPickDetail', 'setPick', 'setCompletePick']),

            // 搜索处理
            handleSearch() {
                // 开启过滤
                this.shouldFilter = true;

                if (this.searchKeyword && this.searchKeyword.trim()) {
                    const keyword = this.searchKeyword.trim();
                    const matchedItem = this.pickDetailList.find(item =>
                        item.productNo && item.productNo === keyword
                    );

                    if (matchedItem && !matchedItem.isPick && !this.isBatchCompleted) {
                        // 找到匹配的商品且未完成拣货
                        if (matchedItem.count === 1) {
                            // 数量为1，自动完成拣货
                            this.autoPick(matchedItem);
                        } else {
                            // 数量大于1，弹框
                            this.openPickModal(matchedItem);
                        }
                    } else if (matchedItem && matchedItem.isPick) {
                        this.$Message.warning('该商品已完成拣货');
                        this.clearSearch();
                    } else if (!matchedItem) {
                        this.$Message.warning('未找到匹配的产品编码');
                        this.clearSearch();
                    }
                } else {
                    // 搜索词为空，清空过滤
                    this.clearSearch();
                }
            },

            // 清空搜索
            clearSearch() {
                this.searchKeyword = '';
                this.shouldFilter = false;  // 关闭过滤，显示全部
            },

            // 自动拣货
            async autoPick(item) {
                try {
                    await this.setPick({
                        id: item.id,
                        count: 1
                    });

                    this.playAudio('pickSuccessAudio');
                    this.$Message.success('拣货成功');

                    this.clearSearch();
                    await this.loadPickDetail();

                    this.$nextTick(() => {
                        const searchInput = document.querySelector('.search-input');
                        if (searchInput) {
                            searchInput.focus();
                        }
                    });
                } catch (error) {
                    this.$Message.error('拣货失败');
                }
            },

            // 播放音频
            playAudio(audioId) {
                try {
                    const audio = document.getElementById(audioId);
                    if (audio) {
                        audio.currentTime = 0;
                        audio.play().catch(error => {
                            console.error('音频播放失败:', error);
                        });
                    }
                } catch (error) {
                    console.error('播放音频时出错:', error);
                }
            },

            async loadPickDetail() {
                try {
                    const result = await this.getPickDetail({
                        batchId: this.batchId
                    });
                    this.pickDetailList = result || [];
                    // 加载后清空搜索和过滤
                    this.clearSearch();
                } catch (error) {
                    this.$Message.error('加载拣货详情失败');
                    this.pickDetailList = [];
                }
            },

            openPickModal(item) {
                this.currentItem = item;
                this.pickCount = item.pickCount === 0 ? item.count : item.pickCount;
                this.showPickModal = true;
            },

            closePickModal() {
                this.showPickModal = false;
                this.currentItem = null;
                this.pickCount = 0;
            },

            async confirmPick() {
                if (!this.currentItem) return;

                if (this.pickCount < 0 || this.pickCount > this.currentItem.count) {
                    this.$Message.error(`拣货数量必须在0-${this.currentItem.count}之间`);
                    return;
                }

                try {
                    await this.setPick({
                        id: this.currentItem.id,
                        count: this.pickCount
                    });

                    this.playAudio('pickSuccessAudio');
                    this.$Message.success('拣货成功');

                    this.closePickModal();
                    this.clearSearch();
                    await this.loadPickDetail();

                    this.$nextTick(() => {
                        const searchInput = document.querySelector('.search-input');
                        if (searchInput) {
                            searchInput.focus();
                        }
                    });
                } catch (error) {
                    this.$Message.error('拣货失败');
                }
            },

            handleCompletePick() {
                if (this.hasIncompleteItems) {
                    this.$Modal.confirm({
                        title: '确认完成拣货',
                        content: '还有商品未完成拣货，确定要强制完成吗？',
                        onOk: () => {
                            this.completePick();
                        }
                    });
                } else {
                    this.completePick();
                }
            },

            async completePick() {
                try {
                    await this.setCompletePick({
                        batchId: this.batchId
                    });

                    this.playAudio('pickSuccessAudio');
                    this.$Message.success('批次拣货完成');

                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 1500);
                } catch (error) {
                    this.$Message.error('完成拣货失败');
                }
            },

            getImageUrl(guid) {
                if (!guid) {
                    return 'https://via.placeholder.com/80x80?text=No+Image';
                }
                if (guid.startsWith('http')) {
                    return guid;
                }
                return `/api/files/download?guid=${guid}`;
            }
        }
    };
</script>

<style scoped>
    .pick-h5 {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding: 8px;
        max-width: 320px;
        margin: 0 auto;
    }

    /* 批次号样式 */
    .batch-info {
        background: white;
        border-radius: 6px;
        padding: 10px 12px;
        margin-bottom: 8px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .batch-number {
        display: flex;
        align-items: center;
        font-size: 14px;
        flex: 1;
        min-width: 0;
    }

    .batch-label {
        width: 65px;
        color: #666;
        flex-shrink: 0;
    }

    .batch-value {
        color: #007aff;
        font-weight: 500;
        flex: 1;
        word-break: break-all;
    }

    .complete-batch-btn {
        background-color: #4caf50;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
        margin-left: 8px;
        cursor: pointer;
    }

        .complete-batch-btn:active {
            opacity: 0.8;
        }

    .search-box {
        background: white;
        border-radius: 6px;
        padding: 8px;
        margin-bottom: 8px;
    }

    .search-row {
        display: flex;
        gap: 6px;
    }

    .search-input {
        flex: 1;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 10px;
        font-size: 13px;
    }

    .search-btn {
        width: 60px;
        height: 36px;
        background-color: #007aff;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 500;
    }

        .search-btn:active {
            opacity: 0.8;
        }

    .pick-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .pick-item {
        background: white;
        border-radius: 6px;
        padding: 12px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        gap: 10px;
    }

    /* 左边图片区域 */
    .item-left {
        width: 80px;
        flex-shrink: 0;
    }

    .product-img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 4px;
        background-color: #f0f0f0;
    }

    /* 右边内容区域 */
    .item-right {
        flex: 1;
        min-width: 0;
    }

    /* 三列统计数据 */
    .stats-row {
        display: flex;
        justify-content: space-between;
        background-color: #f8f8f8;
        border-radius: 4px;
        padding: 6px 4px;
        margin-bottom: 8px;
    }

    .stat-col {
        flex: 1;
        text-align: center;
    }

    .stat-label {
        font-size: 10px;
        color: #666;
        margin-bottom: 2px;
    }

    .stat-value {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

        .stat-value.complete {
            color: #4caf50;
            font-weight: bold;
        }

        .stat-value.incomplete {
            color: #f44336;
            font-weight: bold;
        }

    /* 信息行 - 产品编号和货架号 */
    .info-row {
        display: flex;
        align-items: flex-start;
        font-size: 12px;
        line-height: 1.5;
        margin-bottom: 4px;
    }

    .info-label {
        width: 65px;
        color: #666;
        flex-shrink: 0;
    }

    .info-value {
        color: #333;
        font-weight: 500;
        flex: 1;
        word-break: break-all;
    }

    /* 操作按钮 */
    .action-row {
        margin-top: 8px;
    }

    .pick-btn {
        padding: 8px 12px;
        background-color: #007aff;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 13px;
        width: 100%;
    }

        .pick-btn:active {
            opacity: 0.8;
        }

    .empty-state {
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
    }

    /* 弹框样式 */
    .modal-content {
        padding: 8px 0;
    }

    .modal-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    .modal-label {
        width: 70px;
        color: #666;
        font-size: 13px;
    }

    .modal-value {
        color: #333;
        font-weight: 500;
        font-size: 13px;
        flex: 1;
    }

    .modal-input {
        flex: 1;
        height: 34px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 13px;
    }

        .modal-input:focus {
            border-color: #007aff;
            outline: none;
        }
</style>